import React, { useEffect, useState } from 'react'
import style from "./Divorce.module.css";

import { comma, unComma } from '../../utils/utils';
import { bodyFetch } from "../../api/api";
import { useTitle } from "../../App";
import { consultInitData } from "./data";

import Header from '../../components/Header';
import Title from '../../components/Title';
import FileInput from '../../components/FileInput';
import PropertyRealty from "../../components/property/Realty";
import PropertyFinance from "../../components/property/Finance";
import PropertyCar from "../../components/property/Car";
import PropertyBond from "../../components/property/Bond";
import PropertyDebt from "../../components/property/Debt";
import SheetProperty from "../../components/sheet/Property";
import SheetDebt from '../../components/sheet/Debt';

function Divorce() {
  useTitle("대륜 이혼 진술서")

  const sendApiUrl = process.env.REACT_APP_SEND_API_URL
  const [tab, setTab] = useState("info")
  const [showFiles, setShowFiles] = useState([]);

  // 복사 삭제 가능한 컴포넌트
  // init = localStorage 값 있으면 받아오기
  const checkLocalStorage = (key_name) => {
    let value

    if (["realty_my", "realty_spouse"].includes(key_name)) {
      value = [{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }]
    } else if (["finance_my", "finance_spouse"].includes(key_name)) {
      value = [{ "kind" : "", "detail" : "" }]
    } else if (["car_my", "car_spouse"].includes(key_name)) {
      value = [{ "number" : "", "detail" : "" }]
    } else if (["bond_my", "bond_spouse", "debt_my", "debt_spouse"].includes(key_name)) {
      value = [{ "kind" : "", "detail" : "", "evidence" : "" }]
    } else if (["sheet_my_property", "sheet_spouse_property", "sheet_my_debt", "sheet_spouse_debt"].includes(key_name)) {
      value = [{ "kind" : "", "amount" : "" }]
    } 
    return JSON.parse(localStorage.getItem(key_name)) || value;
  }

  const [propertyMyRealty, setPropertyMyRealty] = useState(checkLocalStorage("realty_my"));
  const [propertySpouseRealty, setPropertySpouseRealty] = useState(checkLocalStorage("realty_spouse"));

  const [propertyMyFinance, setPropertyMyFinance] = useState(checkLocalStorage("finance_my"));
  const [propertySpouseFinance, setPropertySpouseFinance] = useState(checkLocalStorage("finance_spouse"));

  const [propertyMyCar, setPropertyMyCar] = useState(checkLocalStorage("car_my"));
  const [propertySpouseCar, setPropertySpouseCar] = useState(checkLocalStorage("car_spouse"));

  const [propertyMyBond, setPropertyMyBond] = useState(checkLocalStorage("bond_my"));
  const [propertySpouseBond, setPropertySpouseBond] = useState(checkLocalStorage("bond_spouse"));

  const [propertyMyDebt, setPropertyMyDebt] = useState(checkLocalStorage("debt_my"));
  const [propertySpouseDebt, setPropertySpouseDebt] = useState(checkLocalStorage("debt_spouse"));

  const [sheetMyProperty, setSheetMyProperty] = useState(checkLocalStorage("sheet_my_property"));
  const [sheetSpouseProperty, setSheetSpouseProperty] = useState(checkLocalStorage("sheet_spouse_property"));
  const [sheetMyDebt, setSheetMyDebt] = useState(checkLocalStorage("sheet_my_debt"));
  const [sheetSpouseDebt, setSheetSpouseDebt] = useState(checkLocalStorage("sheet_spouse_debt"));

  // 체크박스 value
  const [myProperty, setMyProperty] = useState(0);
  const [myDebt, setMyDebt] = useState(0);
  const [spouseProperty, setSpouseProperty] = useState(0);
  const [spouseDebt, setSpouseDebt] = useState(0);

  // 설문 응답 결과 state
  const [consult, setConsult] = useState(consultInitData)

  // 제출 후 초기화
  const resetConsult = () => {
    const newConsult = [ ...consult ]

    for (let i = 0; i < newConsult.length; i++) {
      if (["realty_my", "realty_spouse"].includes(newConsult[i].key)) {
        newConsult[i].answer = [{ "kind" : "",  "address" : "",  "price" : "",  "debt" : "",  "etc" : "" }]
      } else if (["finance_my", "finance_spouse"].includes(newConsult[i].key)) {
        newConsult[i].answer = [{ "kind" : "",  "detail" : "" }]
      } else if (["car_my", "car_spouse"].includes(newConsult[i].key)) {
        newConsult[i].answer = [{ "number" : "",  "detail" : "" }]
      } else if (["bond_my", "bond_spouse", "debt_my", "debt_spouse"].includes(newConsult[i].key)) {
        newConsult[i].answer = [{ "kind" : "",  "detail" : "",  "evidence" : "" }]
      } else if (["cheating_file", "abandon_file", "treatment_me_file", "treatment_parent_file", "etc_file"].includes(newConsult[i].key)) {
        newConsult[i].answer = [""]
      } else if (["sheet_my_property", "sheet_my_debt", "sheet_spouse_property", "sheet_spouse_debt"].includes(newConsult[i].key)) {
        newConsult[i].answer = [{ "kind" : "",  "amount" : "0" }]
      } else if (["sheet_my_total_property", "sheet_my_total_debt", "sheet_my_net_property", "sheet_spouse_total_property", "sheet_spouse_total_debt", "sheet_spouse_net_property", "sheet_couple_net_property"].includes(newConsult[i].key)) {
        newConsult[i].answer = "0"
      } else {
        newConsult[i].answer = ""
      }
    }

    setConsult(newConsult)
    setPropertyMyRealty([{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }])
    setPropertySpouseRealty([{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }])
    setPropertyMyFinance([{ "kind" : "", "detail" : "" }])
    setPropertySpouseFinance([{ "kind" : "", "detail" : "" }])
    setPropertyMyCar([{ "number" : "", "detail" : "" }])
    setPropertySpouseCar([{ "number" : "", "detail" : "" }])
    setPropertyMyBond([{ "kind" : "", "detail" : "", "evidence" : "" }])
    setPropertySpouseBond([{ "kind" : "", "detail" : "", "evidence" : "" }])
    setPropertyMyDebt([{ "kind" : "", "detail" : "", "evidence" : "" }])
    setPropertySpouseDebt([{ "kind" : "", "detail" : "", "evidence" : "" }])
    setSheetMyProperty([{ "kind" : "", "amount" : "" }])
    setSheetSpouseProperty([{ "kind" : "", "amount" : "" }])
    setSheetMyDebt([{ "kind" : "", "amount" : "" }])
    setSheetSpouseDebt([{ "kind" : "", "amount" : "" }])
    setShowFiles([])
  }

  // 마지막 페이지 - 재산명세표 합계
  const sumItem = (newItems) => {
    let sum = 0 ;
    
    if (newItems && newItems.length !== undefined) {
      for (let i = 0; i < newItems.length ; i++) {
        sum += (newItems[i].amount)*1
      }
    }
    
    return sum
  }

  useEffect(()=>{
    setConsultWithArray()
    setMyProperty(sumItem(consult.filter(data => data.key === "sheet_my_property")[0].answer));
    setMyDebt(sumItem(consult.filter(data => data.key === "sheet_my_debt")[0].answer));
    setSpouseProperty(sumItem(consult.filter(data => data.key === "sheet_spouse_property")[0].answer));
    setSpouseDebt(sumItem(consult.filter(data => data.key === "sheet_spouse_debt")[0].answer));
  },[])

  const setConsultWithArray = () => {
    const newConsult = [ ...consult ]

    for (let i = 0; i < newConsult.length; i++) {
      if (localStorage.getItem(newConsult[i].key) !== null) {
        newConsult[i].answer = JSON.parse(localStorage.getItem(newConsult[i].key))
      } 
    }
    setConsult(newConsult)
  }

  const beforeStep = () => {
    // if(!consultCheck(tab)){
    //   return false;
    // }

    const newConsult = [ ...consult ];

    if(tab === "sheet"){
      setTab("check")
    } else if (tab === "check"){
      setTab("formation")
    } else if (tab === "formation"){
      setTab("career")
    } else if (tab === "career"){
      setTab("debt")
    } else if (tab === "debt"){
      setTab("bond")
    } else if (tab === "bond"){
      setTab("car")
    } else if (tab === "car"){
      setTab("finance")
    } else if (tab === "finance"){
      setTab("realty")
    } else if (tab === "realty"){
      setTab("raise")
    } else if (tab === "raise"){
      setTab("current")
    } else if (tab === "current"){
      setTab("etc")
    } else if (tab === "etc"){
      setTab("treatment_parent")
    } else if (tab === "treatment_parent"){
      setTab("treatment_me")
    } else if (tab === "treatment_me"){
      setTab("abandon")
    } else if (tab === "abandon"){
      setTab("cheating")
    } else if (tab === "cheating"){
      setTab("detail")
    } else if (tab === "detail"){
      setTab("info")
    } else {
      setTab("")
    }
    setConsult(newConsult);
  };

  const nextStep = () => {
    if(!consultCheck(tab)){
      return false;
    }
    
    if(tab === "info"){
      setTab("detail")
    } else if (tab === "detail"){
      setTab("cheating")
    } else if (tab === "cheating"){
      setTab("abandon")
    } else if (tab === "abandon"){
      setTab("treatment_me")
    } else if (tab === "treatment_me"){
      setTab("treatment_parent")
    } else if (tab === "treatment_parent"){
      setTab("etc")
    } else if (tab === "etc"){
      setTab("current")
    } else if (tab === "current"){
      setTab("raise")
    } else if (tab === "raise"){
      setTab("realty")
    } else if (tab === "realty"){
      setTab("finance")
    } else if (tab === "finance"){
      setTab("car")
    } else if (tab === "car"){
      setTab("bond")
    } else if (tab === "bond"){
      setTab("debt")
    } else if (tab === "debt"){
      setTab("career")
    } else if (tab === "career"){
      setTab("formation")
    } else if (tab === "formation"){
      setTab("check")
    } else if (tab === "check"){
      setTab("sheet")
    } else {
      setTab("")
    }
  };

  //반드시 입력해주세요, 숫자만 입력해주세요
  const consultCheck = () => {
    if ((consult.filter((e) => e.key === "info_my_name")[0].answer.length === 0) && tab === "info") {
      alert("의뢰인의 성함을 입력하세요.");
      return false;
    } else if ((consult.filter((e) => e.key === "info_my_tel")[0].answer.length === 0) && tab === "info") {
      alert("의뢰인의 연락처를 입력하세요.");
      return false;
    } 
    // else if ((consult.filter((e) => e.key === "info_my_birth")[0].answer.length === 0) && tab === "info") {
    //   alert("의뢰인의 생년월일을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_my_job")[0].answer.length === 0) && tab === "info") {
    //   alert("의뢰인의 직업을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_my_education")[0].answer.length === 0) && tab === "info") {
    //   alert("의뢰인의 최종학력을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_my_role")[0].answer.length === 0) && tab === "info") {
    //   alert("의뢰인의 혼인관계를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_my_residence")[0].answer.length === 0) && tab === "info") {
    //   alert("의뢰인의 현재 거주지를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_spouse_birth")[0].answer.length === 0) && tab === "info") {
    //   alert("상대방의 생년월일을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_spouse_job")[0].answer.length === 0) && tab === "info") {
    //   alert("상대방의 직업을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_spouse_education")[0].answer.length === 0) && tab === "info") {
    //   alert("상대방의 최종학력을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_spouse_role")[0].answer.length === 0) && tab === "info") {
    //   alert("상대방의 혼인관계를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_spouse_residence")[0].answer.length === 0) && tab === "info") {
    //   alert("상대방의 현재 거주지를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_meet")[0].answer.length === 0) && tab === "info") {
    //   alert("결혼 경위를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "info_living_together")[0].answer.length === 0) && tab === "info") {
    //   alert("동거 기간을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "detail_procedure")[0].answer.length === 0) && tab === "detail") {
    //   alert("혼인에 이르게 된 경위를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "current_now")[0].answer.length === 0) && tab === "current") {
    //   alert("별거 중인지 동거 중인지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "current_reason")[0].answer.length === 0) && tab === "current") {
    //   alert("이혼의 계기가 된 결정적인 사건을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "raise_want")[0].answer.length === 0) && tab === "raise") {
    //   alert("친권 및 양육원자로 지정되시길 원하는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "raise_childcare")[0].answer.length === 0) && tab === "raise") {
    //   alert("현재 자녀 양육은 누가 하고 있는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "raise_role")[0].answer.length === 0) && tab === "raise") {
    //   alert("혼인 생활 중, 자녀 양육에 있어 나와 상대방의 역할은 무엇이었는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "raise_close")[0].answer.length === 0) && tab === "raise") {
    //   alert("자녀들은 부모 중 누구에게 더 애착을 느끼거나 가깝게 생각하는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "career_my_income")[0].answer.length === 0) && tab === "career") {
    //   alert("의뢰인의 현재 월 수입을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "career_my_detail")[0].answer.length === 0) && tab === "career") {
    //   alert("의뢰인의 현재 월 수입 상세 내용을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "career_spouse_income")[0].answer.length === 0) && tab === "career") {
    //   alert("상대방의 현재 월 수입을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "career_spouse_detail")[0].answer.length === 0) && tab === "career") {
    //   alert("상대방의 현재 월 수입 상세 내용을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "formation_my_property")[0].answer.length === 0) && tab === "formation") {
    //   alert("결혼 당시 의뢰인이 가져온 재산을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "formation_spouse_property")[0].answer.length === 0) && tab === "formation") {
    //   alert("결혼 당시 상대방이 가져온 재산을 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "formation_detail")[0].answer.length === 0) && tab === "formation") {
    //   alert("결혼 후 재산 형성 과정 및 의뢰인의 기여도를 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "check_1")[0].answer.length === 0) && tab === "check") {
    //   alert("부동산, 주식, 예금, 보험, 퇴직금 등의 조회를 원하는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "check_2")[0].answer.length === 0) && tab === "check") {
    //   alert("부동산, 주식, 예금, 보험, 퇴직금 등의 조회를 원하는지 입력하세요.");
    //   return false;
    // } else if ((consult.filter((e) => e.key === "check_3")[0].answer.length === 0) && tab === "check") {
    //   alert("기타 확인하고 싶은 재산이 있으신지 입력하세요.");
    //   return false;
    // } 
    return true;
  };

  const consultCheck2 = () => {
    if(!consultCheck()){
      return false;
    }
  
    // return setConsultResult(true);
    // consult에 설명 붙인 값으로 전달하기

    const submitConsult = [ ...consult ]
    const findIndex = (key) => consult.findIndex(data => data.key === key)

    const newFileAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { name : "", url : "" }; 
        newAnswer.name = `증거자료 파일명: ${submitConsult[findIndex(key_name)].answer[i].name}`
        newAnswer.url = `증거자료 파일 링크: <a href="${submitConsult[findIndex(key_name)].answer[i].url}" target="_blank">다운로드</a>`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newFileAnswer("cheating_file")
    newFileAnswer("abandon_file")
    newFileAnswer("treatment_me_file")
    newFileAnswer("treatment_parent_file")
    newFileAnswer("etc_file")

    const newRealtyAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { kind : "", address : "", price : "", debt : "", etc : "" }; 
        newAnswer.kind = `종류: ${submitConsult[findIndex(key_name)].answer[i].kind}`
        newAnswer.address = `재산의 표시: ${submitConsult[findIndex(key_name)].answer[i].address}`
        newAnswer.price = `현재 시세(원) (실거래가): ${submitConsult[findIndex(key_name)].answer[i].price}`
        newAnswer.debt = `채무 (담보대출, 개인 채무 등): ${submitConsult[findIndex(key_name)].answer[i].debt}`
        newAnswer.etc = `(위 기재한) 부동한 형성 경위 및 부동산에 관해 알려주시고 싶으신 사항: ${submitConsult[findIndex(key_name)].answer[i].etc}`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newRealtyAnswer("realty_my")
    newRealtyAnswer("realty_spouse")

    const newFinanceAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { kind : "", detail : "" }; 
        newAnswer.kind = `항목/금융기관: ${submitConsult[findIndex(key_name)].answer[i].kind}`
        newAnswer.detail = `상세 내용: ${submitConsult[findIndex(key_name)].answer[i].detail}`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newFinanceAnswer("finance_my")
    newFinanceAnswer("finance_spouse")

    const newCarAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { number : "", detail : "" }; 
        newAnswer.number = `차량번호: ${submitConsult[findIndex(key_name)].answer[i].number}`
        newAnswer.detail = `상세 내용: ${submitConsult[findIndex(key_name)].answer[i].detail}`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newCarAnswer("car_my")
    newCarAnswer("car_spouse")

    const newBondAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { kind : "", detail : "", evidence : "" }; 
        newAnswer.kind = `항목: ${submitConsult[findIndex(key_name)].answer[i].kind}`
        newAnswer.detail = `상세 내용: ${submitConsult[findIndex(key_name)].answer[i].detail}`
        newAnswer.evidence = `증거자료 유무: ${submitConsult[findIndex(key_name)].answer[i].evidence}`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newBondAnswer("bond_my")
    newBondAnswer("bond_spouse")

    const newDebtAnswer = (key_name) => {
      for (let i = 0; i < submitConsult[findIndex(key_name)].answer.length; i++){
        let newAnswer = { kind : "", detail : "", evidence : "" }; 
        newAnswer.kind = `항목: ${submitConsult[findIndex(key_name)].answer[i].kind}`
        newAnswer.detail = `상세 내용 (채무 액수, 사용처 등): ${submitConsult[findIndex(key_name)].answer[i].detail}`
        newAnswer.evidence = `증거자료 유무: ${submitConsult[findIndex(key_name)].answer[i].evidence}`
        submitConsult[findIndex(key_name)].answer[i] = newAnswer
      }
      return submitConsult[findIndex(key_name)].answer
    }
    newDebtAnswer("debt_my")
    newDebtAnswer("debt_spouse")

    for (let i = 0; i < submitConsult[findIndex("sheet_my_property")].answer.length; i++){
      let newAnswer = { kind : "", amount : "" }; 
      newAnswer.kind = `재산의 표시: ${submitConsult[findIndex("sheet_my_property")].answer[i].kind}`
      newAnswer.amount = `재산의 가액(원): ${submitConsult[findIndex("sheet_my_property")].answer[i].amount}`
      submitConsult[findIndex("sheet_my_property")].answer[i] = newAnswer
    }

    submitConsult[findIndex("sheet_my_total_property")].answer = comma(submitConsult[findIndex("sheet_my_total_property")].answer)

    for (let i = 0; i < submitConsult[findIndex("sheet_spouse_property")].answer.length; i++){
      let newAnswer = { kind : "", amount : "" }; 
      newAnswer.kind = `재산의 표시: ${submitConsult[findIndex("sheet_spouse_property")].answer[i].kind}`
      newAnswer.amount = `재산의 가액(원): ${submitConsult[findIndex("sheet_spouse_property")].answer[i].amount}`
      submitConsult[findIndex("sheet_spouse_property")].answer[i] = newAnswer
    }

    submitConsult[findIndex("sheet_spouse_total_property")].answer = comma(submitConsult[findIndex("sheet_spouse_total_property")].answer)

    for (let i = 0; i < submitConsult[findIndex("sheet_my_debt")].answer.length; i++){
      let newAnswer = { kind : "", amount : "" }; 
      newAnswer.kind = `채무의 표시: ${submitConsult[findIndex("sheet_my_debt")].answer[i].kind}`
      newAnswer.amount = `채무의 가액(원): ${submitConsult[findIndex("sheet_my_debt")].answer[i].amount}`
      submitConsult[findIndex("sheet_my_debt")].answer[i] = newAnswer
    }
    
    submitConsult[findIndex("sheet_my_total_debt")].answer = comma(submitConsult[findIndex("sheet_my_total_debt")].answer)

    for (let i = 0; i < submitConsult[findIndex("sheet_spouse_debt")].answer.length; i++){
      let newAnswer = { kind : "", amount : "" }; 
      newAnswer.kind = `채무의 표시: ${submitConsult[findIndex("sheet_spouse_debt")].answer[i].kind}`
      newAnswer.amount = `채무의 가액(원): ${submitConsult[findIndex("sheet_spouse_debt")].answer[i].amount}`
      submitConsult[findIndex("sheet_spouse_debt")].answer[i] = newAnswer
    }
    
    submitConsult[findIndex("sheet_spouse_total_debt")].answer = comma(submitConsult[findIndex("sheet_spouse_total_debt")].answer)

    submitConsult[findIndex("sheet_my_net_property")].answer = comma(submitConsult[findIndex("sheet_my_net_property")].answer)
    submitConsult[findIndex("sheet_spouse_net_property")].answer = comma(submitConsult[findIndex("sheet_spouse_net_property")].answer)
    submitConsult[findIndex("sheet_couple_net_property")].answer = comma(submitConsult[findIndex("sheet_couple_net_property")].answer)


    if(window.confirm("제출하시겠습니까?")){

      bodyFetch(sendApiUrl, { statement: submitConsult, litigation_name: "이혼 진술서",
          customer_name: submitConsult[findIndex("info_my_name")].answer, case_name: "이혼",
          tel: submitConsult[findIndex("info_my_tel")].answer }, (obj) => {
        if(obj.result) {
          console.log("SUCCESS :: 진술서가 제출되었습니다.")
        } else {
          alert("전송 실패. 다시 시도해주세요")
        }
      }, "POST");

      alert("제출되었습니다.")
      localStorage.clear()
      setTab("info")
      resetConsult()

    } else {
      alert("제출이 취소되었습니다.")
    }
    
  };

  const handleInput = (e) => {
    const newConsult = [ ...consult ]
    const newPropertyMyRealty = [ ...propertyMyRealty ]
    const newPropertySpouseRealty = [ ...propertySpouseRealty ]
    const newPropertyMyFinance = [ ...propertyMyFinance ]
    const newPropertySpouseFinance = [ ...propertySpouseFinance ]
    const newPropertyMyCar = [ ...propertyMyCar ]
    const newPropertySpouseCar = [ ...propertySpouseCar ]
    const newPropertyMyBond = [ ...propertyMyBond ]
    const newPropertySpouseBond = [ ...propertySpouseBond ]
    const newPropertyMyDebt = [ ...propertyMyDebt ]
    const newPropertySpouseDebt = [ ...propertySpouseDebt ]
    const newSheetMyProperty = [ ...sheetMyProperty ]
    const newSheetSpouseProperty = [ ...sheetSpouseProperty ]
    const newSheetMyDebt = [ ...sheetMyDebt ]
    const newSheetSpouseDebt = [ ...sheetSpouseDebt ]

    //배열을 넣으면, handleInput에서 전달받는 property 값을 업데이트 한다.
    const updateValue = (array=[], property) => {
      array.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item[property] = e.currentTarget.value
        } 
        return item;
      })
    }

    // if(e.currentTarget.name === "realty_my_kind") {
    //   updateValue(newConsult.filter((e) => e.key === "realty_my")[0].answer, "kind")
    //   updateValue(newPropertyMyRealty, "kind")
    // } 

    if(e.currentTarget.name === "info_my_name") {
      newConsult.filter((e) => e.key === "info_my_name")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_tel") {
      newConsult.filter((e) => e.key === "info_my_tel")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_birth") {
      newConsult.filter((e) => e.key === "info_my_birth")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_job") {
      newConsult.filter((e) => e.key === "info_my_job")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_education") {
      newConsult.filter((e) => e.key === "info_my_education")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_role") {
      newConsult.filter((e) => e.key === "info_my_role")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_my_residence") {
      newConsult.filter((e) => e.key === "info_my_residence")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_spouse_birth") {
      newConsult.filter((e) => e.key === "info_spouse_birth")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_spouse_job") {
      newConsult.filter((e) => e.key === "info_spouse_job")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_spouse_education") {
      newConsult.filter((e) => e.key === "info_spouse_education")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_spouse_role") {
      newConsult.filter((e) => e.key === "info_spouse_role")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_spouse_residence") {
      newConsult.filter((e) => e.key === "info_spouse_residence")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_meet") {
      newConsult.filter((e) => e.key === "info_meet")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_living_together") {
      newConsult.filter((e) => e.key === "info_living_together")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_wedding_date") {
      newConsult.filter((e) => e.key === "info_wedding_date")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_registration_date") {
      newConsult.filter((e) => e.key === "info_registration_date")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_separation_period") {
      newConsult.filter((e) => e.key === "info_separation_period")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_children") {
      newConsult.filter((e) => e.key === "info_children")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_delivery_address") {
      newConsult.filter((e) => e.key === "info_delivery_address")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "info_intention") {
      newConsult.filter((e) => e.key === "info_intention")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "detail_procedure") {
      newConsult.filter((e) => e.key === "detail_procedure")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "cheating_text") {
      newConsult.filter((e) => e.key === "cheating_text")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "cheating_file") {
      newConsult.filter((e) => e.key === "cheating_file")[0].answer = showFiles
    } else if(e.currentTarget.name === "abandon_text") {
      newConsult.filter((e) => e.key === "abandon_text")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "abandon_file") {
      newConsult.filter((e) => e.key === "abandon_file")[0].answer = showFiles
    } else if(e.currentTarget.name === "treatment_me_text") {
      newConsult.filter((e) => e.key === "treatment_me_text")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "treatment_me_file") {
      newConsult.filter((e) => e.key === "treatment_me_file")[0].answer = showFiles
    } else if(e.currentTarget.name === "treatment_parent_text") {
      newConsult.filter((e) => e.key === "treatment_parent_text")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "treatment_parent_file") {
      newConsult.filter((e) => e.key === "treatment_parent_file")[0].answer = showFiles
    } else if(e.currentTarget.name === "etc_text") {
      newConsult.filter((e) => e.key === "etc_text")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "etc_file") {
      newConsult.filter((e) => e.key === "etc_file")[0].answer = showFiles
    } else if(e.currentTarget.name === "current_now") {
      newConsult.filter((e) => e.key === "current_now")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "current_reason") {
      newConsult.filter((e) => e.key === "current_reason")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_want") {
      newConsult.filter((e) => e.key === "raise_want")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_childcare") {
      newConsult.filter((e) => e.key === "raise_childcare")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_role") {
      newConsult.filter((e) => e.key === "raise_role")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_close") {
      newConsult.filter((e) => e.key === "raise_close")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_appeal") {
      newConsult.filter((e) => e.key === "raise_appeal")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "raise_problem") {
      newConsult.filter((e) => e.key === "raise_problem")[0].answer = e.currentTarget.value;
    } 
    else if(e.currentTarget.name === "realty_my_kind") {
      newConsult.filter((e) => e.key === "realty_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    }     
    else if(e.currentTarget.name === "realty_my_address") {
      newConsult.filter((e) => e.key === "realty_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.address = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.address = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_my_price") {
      newConsult.filter((e) => e.key === "realty_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.price = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.price = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_my_debt") {
      newConsult.filter((e) => e.key === "realty_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.debt = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.debt = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_my_etc") {
      newConsult.filter((e) => e.key === "realty_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.etc = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.etc = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_spouse_kind") {
      newConsult.filter((e) => e.key === "realty_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_spouse_address") {
      newConsult.filter((e) => e.key === "realty_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.address = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.address = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_spouse_price") {
      newConsult.filter((e) => e.key === "realty_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.price = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.price = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_spouse_debt") {
      newConsult.filter((e) => e.key === "realty_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.debt = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.debt = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "realty_spouse_etc") {
      newConsult.filter((e) => e.key === "realty_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.etc = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseRealty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.etc = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "finance_my_kind") {
      newConsult.filter((e) => e.key === "finance_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyFinance.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "finance_my_detail") {
      newConsult.filter((e) => e.key === "finance_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyFinance.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "finance_spouse_kind") {
      newConsult.filter((e) => e.key === "finance_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseFinance.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "finance_spouse_detail") {
      newConsult.filter((e) => e.key === "finance_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseFinance.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "car_my_number") {
      newConsult.filter((e) => e.key === "car_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.number = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyCar.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.number = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "car_my_detail") {
      newConsult.filter((e) => e.key === "car_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyCar.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "car_spouse_number") {
      newConsult.filter((e) => e.key === "car_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.number = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseCar.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.number = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "car_spouse_detail") {
      newConsult.filter((e) => e.key === "car_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseCar.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_my_kind") {
      newConsult.filter((e) => e.key === "bond_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_my_detail") {
      newConsult.filter((e) => e.key === "bond_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_my_evidence") {
      newConsult.filter((e) => e.key === "bond_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_spouse_kind") {
      newConsult.filter((e) => e.key === "bond_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_spouse_detail") {
      newConsult.filter((e) => e.key === "bond_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "bond_spouse_evidence") {
      newConsult.filter((e) => e.key === "bond_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseBond.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_my_kind") {
      newConsult.filter((e) => e.key === "debt_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_my_detail") {
      newConsult.filter((e) => e.key === "debt_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_my_evidence") {
      newConsult.filter((e) => e.key === "debt_my")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        } 
        return item;
      })

      newPropertyMyDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_spouse_kind") {
      newConsult.filter((e) => e.key === "debt_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_spouse_detail") {
      newConsult.filter((e) => e.key === "debt_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.detail = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "debt_spouse_evidence") {
      newConsult.filter((e) => e.key === "debt_spouse")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        } 
        return item;
      })

      newPropertySpouseDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.evidence = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "career_my_income") {
      newConsult.filter((e) => e.key === "career_my_income")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "career_my_detail") {
      newConsult.filter((e) => e.key === "career_my_detail")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "career_spouse_income") {
      newConsult.filter((e) => e.key === "career_spouse_income")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "career_spouse_detail") {
      newConsult.filter((e) => e.key === "career_spouse_detail")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "formation_my_property") {
      newConsult.filter((e) => e.key === "formation_my_property")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "formation_spouse_property") {
      newConsult.filter((e) => e.key === "formation_spouse_property")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "formation_detail") {
      newConsult.filter((e) => e.key === "formation_detail")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "check_1") {
      if(e.currentTarget.value==="아니오" || e.currentTarget.value==="예금만 원함") {
        newConsult.filter((e) => e.key === "check_1_company")[0].answer = "";
        newConsult.filter((e) => e.key === "check_1_address")[0].answer = "";
      }
      newConsult.filter((e) => e.key === "check_1")[0].answer = e.currentTarget.value;

    } else if(e.currentTarget.name === "check_1_company") {
      newConsult.filter((e) => e.key === "check_1_company")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "check_1_address") {
      newConsult.filter((e) => e.key === "check_1_address")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "check_2") {
      newConsult.filter((e) => e.key === "check_2")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "check_3") {
      if(e.currentTarget.value==="아니오") {
        newConsult.filter((e) => e.key === "check_3_detail")[0].answer = "";
      }
      newConsult.filter((e) => e.key === "check_3")[0].answer = e.currentTarget.value;
      
    } else if(e.currentTarget.name === "check_3_detail") {
      newConsult.filter((e) => e.key === "check_3_detail")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_my_property_kind") {
      newConsult.filter((e) => e.key === "sheet_my_property")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newSheetMyProperty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "sheet_my_property_amount") {
      newConsult.filter((e) => e.key === "sheet_my_property")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        } 
        return item;
      })

      newSheetMyProperty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        }
        return item;
      })
      setMyProperty(sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer));
      newConsult.filter((e) => e.key === "sheet_my_total_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer);
      newConsult.filter((e) => e.key === "sheet_my_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_couple_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer) + sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
    } else if(e.currentTarget.name === "sheet_my_total_property") {
      // newConsult.filter((e) => e.key === "sheet_my_total_property")[0].answer = myProperty;
    } else if(e.currentTarget.name === "sheet_my_debt_kind") {
      newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newSheetMyDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "sheet_my_debt_amount") {
      newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        } 
        return item;
      })

      newSheetMyDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        }
        return item;
      })
      setMyDebt(sumItem(newSheetMyDebt));
      newConsult.filter((e) => e.key === "sheet_my_total_debt")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_my_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_couple_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer) + sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
    } else if(e.currentTarget.name === "sheet_my_total_debt") {
      // newConsult.filter((e) => e.key === "sheet_my_total_debt")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_my_net_property") {
      // newConsult.filter((e) => e.key === "sheet_my_net_property")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_spouse_property_kind") {
      newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newSheetSpouseProperty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "sheet_spouse_property_amount") {
      newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        } 
        return item;
      })

      newSheetSpouseProperty.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        }
        return item;
      })
      setSpouseProperty(sumItem(newSheetSpouseProperty));
      newConsult.filter((e) => e.key === "sheet_spouse_total_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer);
      newConsult.filter((e) => e.key === "sheet_spouse_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_couple_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer) + sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
    } else if(e.currentTarget.name === "sheet_spouse_total_property") {
      // newConsult.filter((e) => e.key === "sheet_spouse_total_property")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_spouse_debt_kind") {
      newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        } 
        return item;
      })

      newSheetSpouseDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.kind = e.currentTarget.value
        }
        return item;
      })
    } else if(e.currentTarget.name === "sheet_spouse_debt_amount") {
      newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer.map((item, index) => {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        } 
        return item;
      })

      newSheetSpouseDebt.map((item, index)=> {
        if(Number(e.currentTarget.dataset.index) === index){
          item.amount = unComma(e.currentTarget.value)
        }
        return item;
      })
      setSpouseDebt(sumItem(newSheetSpouseDebt));
      newConsult.filter((e) => e.key === "sheet_spouse_total_debt")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_spouse_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
      newConsult.filter((e) => e.key === "sheet_couple_net_property")[0].answer = sumItem(newConsult.filter((e) => e.key === "sheet_my_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_my_debt")[0].answer) + sumItem(newConsult.filter((e) => e.key === "sheet_spouse_property")[0].answer) - sumItem(newConsult.filter((e) => e.key === "sheet_spouse_debt")[0].answer);
    } else if(e.currentTarget.name === "sheet_spouse_total_debt") {
      // newConsult.filter((e) => e.key === "sheet_spouse_total_debt")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_spouse_net_property") {
      // newConsult.filter((e) => e.key === "sheet_spouse_net_property")[0].answer = e.currentTarget.value;
    } else if(e.currentTarget.name === "sheet_couple_net_property") {
      // newConsult.filter((e) => e.key === "sheet_couple_net_property")[0].answer = e.currentTarget.value;
    } 

    sumItem()
    postLocalStorage()
    setConsult(newConsult)
    setPropertyMyRealty(newPropertyMyRealty)
    setPropertySpouseRealty(newPropertySpouseRealty)
    setPropertyMyFinance(newPropertyMyFinance)
    setPropertySpouseFinance(newPropertySpouseFinance)
    setPropertyMyCar(newPropertyMyCar)
    setPropertySpouseCar(newPropertySpouseCar)
    setPropertyMyBond(newPropertyMyBond)
    setPropertySpouseBond(newPropertySpouseBond)
    setPropertyMyDebt(newPropertyMyDebt)
    setPropertySpouseDebt(newPropertySpouseDebt)
    setSheetMyProperty(newSheetMyProperty)
    setSheetSpouseProperty(newSheetSpouseProperty)
    setSheetMyDebt(newSheetMyDebt)
    setSheetSpouseDebt(newSheetSpouseDebt)
  }

  // 아이템 추가
  const handleAddItem = (key) => {
    const newConsult = [ ...consult ]
    const findIndex = consult.findIndex(data => data.key === key)

    switch(key) {
      case "realty_my" : 
        newConsult[findIndex].answer = [{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }, ...newConsult[findIndex].answer]
        setPropertyMyRealty([{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }, ...propertyMyRealty])
        break;

      case "realty_spouse" : 
        newConsult[findIndex].answer = [{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }, ...newConsult[findIndex].answer]
        setPropertySpouseRealty([{ "kind" : "", "address" : "", "price" : "", "debt" : "", "etc" : "" }, ...propertySpouseRealty])
        break;

      case "finance_my" :  
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "" }, ...newConsult[findIndex].answer]
        setPropertyMyFinance([{ "kind" : "", "detail" : "" }, ...propertyMyFinance])
        break;

      case "finance_spouse" :
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "" }, ...newConsult[findIndex].answer] 
        setPropertySpouseFinance([{ "kind" : "", "detail" : "" }, ...propertySpouseFinance])
        break;

      case "car_my" : 
        newConsult[findIndex].answer = [{ "number" : "", "detail" : "" }, ...newConsult[findIndex].answer]
        setPropertyMyCar([{ "number" : "", "detail" : "" }, ...propertyMyCar])
        break;

      case "car_spouse" :  
        newConsult[findIndex].answer = [{ "number" : "", "detail" : "" }, ...newConsult[findIndex].answer]
        setPropertySpouseCar([{ "number" : "", "detail" : "" }, ...propertySpouseCar])
        break;

      case "bond_my" : 
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
        setPropertyMyBond([{ "kind" : "", "detail" : "", "evidence" : "" }, ...propertyMyBond])
        break;

      case "bond_spouse" : 
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
        setPropertySpouseBond([{ "kind" : "", "detail" : "", "evidence" : "" }, ...propertySpouseBond])
        break;

      case "debt_my" : 
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
        setPropertyMyDebt([{ "kind" : "", "detail" : "", "evidence" : "" }, ...propertyMyDebt])
        break;

      case "debt_spouse" : 
        newConsult[findIndex].answer = [{ "kind" : "", "detail" : "", "evidence" : "" }, ...newConsult[findIndex].answer]
        setPropertySpouseDebt([{ "kind" : "", "detail" : "", "evidence" : "" }, ...propertySpouseDebt])
        break;

      case "sheet_my_property" : 
        newConsult[findIndex].answer = [{ "kind" : "", "amount" : "" }, ...newConsult[findIndex].answer]
        setSheetMyProperty([{ "kind" : "", "amount" : "" }, ...sheetMyProperty])
        break;
    
      case "sheet_spouse_property" : 
        newConsult[findIndex].answer = [{ "kind" : "", "amount" : "" }, ...newConsult[findIndex].answer]
        setSheetSpouseProperty([{ "kind" : "", "amount" : "" }, ...sheetSpouseProperty])
        break;

      case "sheet_my_debt" : 
        newConsult[findIndex].answer = [{ "kind" : "", "amount" : "" }, ...newConsult[findIndex].answer]
        setSheetMyDebt([{ "kind" : "", "amount" : "" }, ...sheetMyDebt])
        break;
    
      case "sheet_spouse_debt" : 
        newConsult[findIndex].answer = [{ "kind" : "", "amount" : "" }, ...newConsult[findIndex].answer]
        setSheetSpouseDebt([{ "kind" : "", "amount" : "" }, ...sheetSpouseDebt])
        break;

      default :

    }
    setConsult(newConsult)
  }

  const handleDeleteItem = (key) => {
    const newConsult = [ ...consult ]
    const findIndex = consult.findIndex(data => data.key === key)

    switch(key) {
      case "realty_my" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertyMyRealty(propertyMyRealty.slice(1))
        break;

      case "realty_spouse" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertySpouseRealty(propertySpouseRealty.slice(1))
        break;

      case "finance_my" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertyMyFinance(propertyMyFinance.slice(1))
        break;

      case "finance_spouse" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertySpouseFinance(propertySpouseFinance.slice(1))
        break;

      case "car_my" : 
      newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertyMyCar(propertyMyCar.slice(1))
        break;

      case "car_spouse" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertySpouseCar(propertySpouseCar.slice(1))
        break;

      case "bond_my" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertyMyBond(propertyMyBond.slice(1))
        break;

      case "bond_spouse" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertySpouseBond(propertySpouseBond.slice(1))
        break;

      case "debt_my" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertyMyDebt(propertyMyDebt.slice(1))
        break;

      case "debt_spouse" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setPropertySpouseDebt(propertySpouseDebt.slice(1))
        break;

      case "sheet_my_property" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setSheetMyProperty(sheetMyProperty.slice(1))
        break;
    
      case "sheet_spouse_property" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setSheetSpouseProperty(sheetSpouseProperty.slice(1))
        break;

      case "sheet_my_debt" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setSheetMyDebt(sheetMyDebt.slice(1))
        break;
    
      case "sheet_spouse_debt" : 
        newConsult[findIndex].answer = newConsult[findIndex].answer.slice(1)
        setSheetSpouseDebt(sheetSpouseDebt.slice(1))
        break;

      default :

    }
    setConsult(newConsult)
  }

  // localStorage를 state로 바로 꺼내쓰기 어려움
  useEffect(()=> {
    const newConsult = [ ...consult ]

    newConsult.filter((e) => e.key === "cheating_file")[0].answer = showFiles.filter(data => data.key === "cheating")
    newConsult.filter((e) => e.key === "abandon_file")[0].answer = showFiles.filter(data => data.key === "abandon")
    newConsult.filter((e) => e.key === "treatment_me_file")[0].answer = showFiles.filter(data => data.key === "treatment_me")
    newConsult.filter((e) => e.key === "treatment_parent_file")[0].answer = showFiles.filter(data => data.key === "treatment_parent")
    newConsult.filter((e) => e.key === "etc_file")[0].answer = showFiles.filter(data => data.key === "etc")
  
  },[consult])

  const getShowFiles = (data) => {
    setShowFiles(data)
  }

  const getLocalStorage = (key_name) => JSON.parse(localStorage.getItem(key_name))

  const postLocalStorage = () => {
    for (let i = 0; i < consult.length; i++) {
      const inputValue = JSON.stringify(consult[i].answer)
      localStorage.setItem(consult[i].key, inputValue);
    }

    localStorage.setItem("realty_my", JSON.stringify(propertyMyRealty))
    localStorage.setItem("realty_spouse", JSON.stringify(propertySpouseRealty))
    localStorage.setItem("finance_my", JSON.stringify(propertyMyFinance))
    localStorage.setItem("finance_spouse", JSON.stringify(propertySpouseFinance))
    localStorage.setItem("car_my", JSON.stringify(propertyMyCar))
    localStorage.setItem("car_spouse", JSON.stringify(propertySpouseCar))
    localStorage.setItem("bond_my", JSON.stringify(propertyMyBond))
    localStorage.setItem("bond_spouse", JSON.stringify(propertySpouseBond))
    localStorage.setItem("debt_my", JSON.stringify(propertyMyDebt))
    localStorage.setItem("debt_spouse", JSON.stringify(propertySpouseDebt))
    localStorage.setItem("sheet_my_property", JSON.stringify(sheetMyProperty))
    localStorage.setItem("sheet_spouse_property", JSON.stringify(sheetSpouseProperty))
    localStorage.setItem("sheet_my_debt", JSON.stringify(sheetMyDebt))
    localStorage.setItem("sheet_spouse_debt", JSON.stringify(sheetSpouseDebt))
  }

  return (
    <>
      <Header />
      <Title title={"이혼"} />

      {/* 1. 기초사항 */}
      { tab === "info" ? (

        <section>

          <div className={style.item_input_text}>
            <p className={style.tit}>작성자</p>
            <input type="text" name="info_my_name" placeholder='예) 홍길동' value={consult.filter((e)=>e.key === "info_my_name")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>작성자 연락처</p>
            <input type="text" name="info_my_tel" placeholder='예) 01012345678' value={consult.filter((e)=>e.key === "info_my_tel")[0].answer} onChange={handleInput} />
          </div>

          <p className={style.main_tit}>1. 기초사항</p>
          <p className={style.tit_desc}>(법원에서 가사조사 시 확인하는) 당사자 인적사항</p>

          {/* 1. 기초사항 - 의뢰인 */}
          <p className={style.h2}>의뢰인</p>

          <div className={style.item_input_text}>
            <p className={style.tit}>생년월일</p>
            <input type="text" name="info_my_birth" placeholder='예) 1970.12.30' value={consult.filter((e)=>e.key === "info_my_birth")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>직업</p>
            <input type="text" name="info_my_job" placeholder='예) 자영업' value={consult.filter((e)=>e.key === "info_my_job")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>최종학력</p>
            <input type="text" name="info_my_education" value={consult.filter((e)=>e.key === "info_my_education")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>혼인관계</p>
            <input type="text" name="info_my_role" placeholder='예) 초혼, 재혼' value={consult.filter((e)=>e.key === "info_my_role")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>현재 거주지</p>
            <input type="text" name="info_my_residence" value={consult.filter((e)=>e.key === "info_my_residence")[0].answer} onChange={handleInput} />
          </div>
          
          {/* 1. 기초사항 - 상대방 */}
          <p className={style.h2}>상대방</p>

          <div className={style.item_input_text}>
            <p className={style.tit}>생년월일</p>
            <input type="text" name="info_spouse_birth" placeholder='예) 1970.12.30' value={consult.filter((e)=>e.key === "info_spouse_birth")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>직업</p>
            <input type="text" name="info_spouse_job" placeholder='예) 자영업' value={consult.filter((e)=>e.key === "info_spouse_job")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>최종학력</p>
            <input type="text" name="info_spouse_education" value={consult.filter((e)=>e.key === "info_spouse_education")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>혼인관계</p>
            <input type="text" name="info_spouse_role" value={consult.filter((e)=>e.key === "info_spouse_role")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>현재 거주지</p>
            <input type="text" name="info_spouse_residence" value={consult.filter((e)=>e.key === "info_spouse_residence")[0].answer} onChange={handleInput} />
          </div>

          {/* 1. 기초사항 - 상세 인적사항 */}
          <p className={style.h2}>상세 인적사항</p>

          <div className={style.item_input_text}>
            <p className={style.tit}>결혼 경위</p>
            <input type="text" name="info_meet" placeholder='예) 중매/연애/소개/선/등등' value={consult.filter((e)=>e.key === "info_meet")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>동거 기간</p>
            <input type="text" name="info_living_together" placeholder='예) 1980.5.5.~2020.2.4.' value={consult.filter((e)=>e.key === "info_living_together")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>결혼식 일자</p>
            <input type="text" name="info_wedding_date" placeholder='예) 결혼식을 하지 않은 경우 기재 생략 가능' value={consult.filter((e)=>e.key === "info_wedding_date")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>혼인신고 일자</p>
            <input type="text" name="info_registration_date" placeholder='예) 결혼식을 하지 않은 경우 기재 생략 가능' value={consult.filter((e)=>e.key === "info_registration_date")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>별거 기간</p>
            <input type="text" name="info_separation_period" placeholder='예) 2020.2.5.~현재' value={consult.filter((e)=>e.key === "info_separation_period")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>자녀</p>
            <input type="text" name="info_children" placeholder='예) 첫째 아들(성인), 둘째 딸(고2) / 상대방은 전혼 자녀 1명이 있음' value={consult.filter((e)=>e.key === "info_children")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}><span className={style.brown}>(의뢰인분이 원고인 경우)</span></p>
            <p className={style.tit}>상대방에게 <span className={style.red}>송달을 희망하는 주소지</span></p>
            <input type="text" name="info_delivery_address" value={consult.filter((e)=>e.key === "info_delivery_address")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>상대방의 이혼 의사</p>
            <input type="text" name="info_intention" placeholder='예) 이혼의사 명확하나, 재산분할 갖고 합의가 안됨' value={consult.filter((e)=>e.key === "info_intention")[0].answer} onChange={handleInput} />
          </div>

        </section>

      ) :null}

      {/* 2. 혼인에 이르게 된 경위 */}
      { tab === "detail" ? (

        <section>

          <p className={style.main_tit}>2. 혼인에 이르게 된 경위</p>
          <p className={style.tit_desc}>① 어떻게 만나서, 어떠한 계기로 결혼 및 동거에 이르게 되었는지, 결혼 준비 과정은 어떠했는지 적어주시고,</p>
          <p className={style.tit_desc}>② 아울러 배우자의 성격이나 배우자 가족들에 대해 특별히 알려주시고 싶으신 부분이 있다면 기술해주세요</p>

          <div className={style.item_input_textarea}>
            <textarea name="detail_procedure" value={consult.filter((e)=>e.key === "detail_procedure")[0].answer} onChange={handleInput} />
          </div>

        </section>

      ) : null}

      {/* 3. 이혼 사유 - 가 - (1) 상대방의 부정 행위 */}
      { tab === "cheating" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>
          <p className={style.h3}>가. 재판상 이혼 사유</p>
          <p className={style.tit_desc}>
            &#91;아래 <span className={style.red}>(1)부터 (5)번 항목에 해당하는 사실관계가 있으면 육하원칙에 따라 시간 순으로 기재</span>해주시면 되겠습니다. <br/>
            아울러 정확한 일자를 모르는 경우에는 &#34;2020년 10월경, 2020년 봄 경, 2019년 경&#34;등으로라도 기재해주시기 바랍니다. <br/>
            아울러 가능한 구체적으로 기재해주시고, <span className={style.red}>관련 증거가 있는 경우 어떤 증거가 있는지</span> 적고 함께 보내주세요&#93;
          </p>

          <p className={style.h4}>(1) 상대방의 부정 행위</p>
          <p className={style.tit_sub_desc}>(제3자와의 교제, 성관계, 동거 등 외도)</p>

          <div className={style.item_input_textarea}>
            <textarea name="cheating_text" value={consult.filter((e)=>e.key === "cheating_text")[0].answer} onChange={handleInput} />
          </div>

          <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />

          <p className={style.tit_desc}><span className={style.red_bold}>관련 증거:</span> 사진, 녹음파일, 문자메시지, 그 외 증거자료가 
          있으시면 <span className={style.red}>&#34;부정행위증거자료1,2&#34;등으로 파일명 또는 제목을 정해서 이메일 또는 우편</span>으로 보내주시기 바랍니다.</p>

        </section>

      ) : null}

      {/* 3. 이혼 사유 - 가 - (2) 상대방의 유기 행위 */}
      { tab === "abandon" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>

          <p className={style.h4}>(2) 상대방의 유기 행위</p>
          <p className={style.tit_sub_desc}>(장기간 별거 및 부양 안 함, 지속적인 외박 및 가출)</p>

          <div className={style.item_input_textarea}>
            <textarea name="abandon_text" value={consult.filter((e)=>e.key === "abandon_text")[0].answer} onChange={handleInput} />
          </div>

          <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />

          <p className={style.tit_desc}><span className={style.red_bold}>관련 증거:</span> 사진, 녹음파일, 문자메시지, 그 외 증거자료가 
          있으시면 <span className={style.red}>&#34;부정행위증거자료1,2&#34;등으로 파일명 또는 제목을 정해서 이메일 또는 우편</span>으로 보내주시기 바랍니다.</p>

        </section>

      ) : null}

      {/* 3. 이혼 사유 - 가 - (3) 상대방 및 상대방 부모님이 나에게 행한 부당대우 */}
      { tab === "treatment_me" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>

          <p className={style.h4}>(3) 상대방 및 상대방 부모님이 나에게 행한 부당대우</p>
          <p className={style.tit_sub_desc}>(폭언, 폭행, 학대, 무시, 모욕, 상대방 부모님의 괴롭힘 및 갈등)</p>

          <div className={style.item_input_textarea}>
            <textarea name="treatment_me_text" value={consult.filter((e)=>e.key === "treatment_me_text")[0].answer} onChange={handleInput} />
          </div>

          <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />

          <p className={style.tit_desc}><span className={style.red_bold}>관련 증거:</span> 사진, 녹음파일, 문자메시지, 그 외 증거자료가 
          있으시면 <span className={style.red}>&#34;부정행위증거자료1,2&#34;등으로 파일명 또는 제목을 정해서 이메일 또는 우편</span>으로 보내주시기 바랍니다.</p>

        </section>

      ) : null}

      {/* 3. 이혼 사유 - 가 - (4) 상대방이 나의 부모님에게 행한 부당대우 */}
      { tab === "treatment_parent" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>

          <p className={style.h4}>(4) 상대방이 나의 부모님에게 행한 부당대우</p>
          <p className={style.tit_sub_desc}>(폭언, 폭행, 무시, 모욕, 괴롭힘 및 갈등)</p>

          <div className={style.item_input_textarea}>
            <textarea name="treatment_parent_text" value={consult.filter((e)=>e.key === "treatment_parent_text")[0].answer} onChange={handleInput} />
          </div>

          <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />

          <p className={style.tit_desc}><span className={style.red_bold}>관련 증거:</span> 사진, 녹음파일, 문자메시지, 그 외 증거자료가 
          있으시면 <span className={style.red}>&#34;부정행위증거자료1,2&#34;등으로 파일명 또는 제목을 정해서 이메일 또는 우편</span>으로 보내주시기 바랍니다.</p>

        </section>

      ) : null}

      {/* 3. 이혼 사유 - 가 - (5) 기타 혼인을 계속하기 어려운 중대한 사유 */}
      { tab === "etc" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>

          <p className={style.h4}>(5) 기타 혼인을 계속하기 어려운 중대한 사유</p>
          <p className={style.tit_sub_desc}>(중독(음주, 마약, 도박, 게임), 극복할 수 없는 성격차이, 의처증 및 의부증, 경제적 무책임 등)</p>

          <div className={style.item_input_textarea}>
            <textarea name="etc_text" value={consult.filter((e)=>e.key === "etc_text")[0].answer} onChange={handleInput} />
          </div>

          <FileInput tab={tab} consult={consult} handleInput={handleInput} showFiles={showFiles} getShowFiles={getShowFiles} />

          <p className={style.tit_desc}><span className={style.red_bold}>관련 증거:</span> 사진, 녹음파일, 문자메시지, 그 외 증거자료가 
          있으시면 <span className={style.red}>&#34;부정행위증거자료1,2&#34;등으로 파일명 또는 제목을 정해서 이메일 또는 우편</span>으로 보내주시기 바랍니다.</p>

        </section>

      ) : null}
      
      {/* 3. 이혼 사유 - 나 */}
      { tab === "current" ? (

        <section>

          <p className={style.main_tit}>3. 이혼 사유</p>
          <p className={style.h3}>나. 현재 혼인관계 상태</p>

          <p className={style.h4}>(1) 별거 중인지 동거 중인지</p>
          <p className={style.tit_sub_desc}>(별거 중이라면 언제부터 별거하였고, 그 계기가 무엇인지)</p>

          <div className={style.item_input_textarea}>
            <textarea name="current_now" value={consult.filter((e)=>e.key === "current_now")[0].answer} onChange={handleInput} />
          </div>

          <p className={style.h4}>(2) 현재 상태에 대한 진술 및 이혼의 계기가 된 결정적인 사건</p>

          <div className={style.item_input_textarea}>
            <textarea name="current_reason" value={consult.filter((e)=>e.key === "current_reason")[0].answer} onChange={handleInput} />
          </div>

        </section>

      ) : null}

      {/* 4. 자녀 양육 */}
      { tab === "raise" ? (

        <section>

          <p className={style.main_tit}>4. 자녀 양육</p>

          <div className={style.item_input_text}>
            <p className={style.tit}>친권 및 양육원자로 지정되시길 원하시나요?</p>
            <input type="text" name="raise_want" value={consult.filter((e)=>e.key === "raise_want")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>현재 자녀 양육은 누가 하고 있나요?</p>
            <input type="text" name="raise_childcare" value={consult.filter((e)=>e.key === "raise_childcare")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>혼인 생활 중, 자녀 양육에 있어 나와 상대방의 역할은 무엇이었나요?</p>
            <input type="text" name="raise_role" value={consult.filter((e)=>e.key === "raise_role")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>자녀들은 부모 중 누구에게 더 애착을 느끼거나 가깝게 생각하나요?</p>
            <input type="text" name="raise_close" value={consult.filter((e)=>e.key === "raise_close")[0].answer} onChange={handleInput} />
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}><span className={style.brown}>(친권 양육권 주장을 원하시는 분만)</span></p>
            <p className={style.tit}>내가 양육권자가 되어야 하는 이유 및 그간의 양육자로서의 역할을 잘 해온 내용</p>
            <div className={style.item_input_textarea}>
              <textarea name="raise_appeal" value={consult.filter((e)=>e.key === "raise_appeal")[0].answer} onChange={handleInput} />
            </div>
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}><span className={style.brown}>(친권 양육권 주장을 원하시는 분만)</span></p>
            <p className={style.tit}>상대방이 양육권자로 지정되면 안 되는 이유 및 그간 상대방이 양육자로서의 역할을 잘 하지 못했다거나 문제가 있었다는 내용</p>
            <div className={style.item_input_textarea}>
              <textarea name="raise_problem" value={consult.filter((e)=>e.key === "raise_problem")[0].answer} onChange={handleInput} />
            </div>
          </div>

        </section>

      ) : null}

      {/* 5. 재산 분할 - 가 - (1) 현재 소유 중인 부동산 */}
      { tab === "realty" ? (

        <section>

          <p className={style.main_tit}>5. 재산분할</p>
          <p className={style.tit_desc}>
            - 현재 알고 있는 내용을 가능한 자세히 적어주시면 재산분할 비율, 기여도 주장에 도움이 됩니다.
          </p>
          <p className={style.tit_desc}>
            - 정확히 알지 못하는 경우, 대략적인 내용이라도 적어주세요. (예: 농협은행 예금 3천만 원 정도)
          </p>

          <p className={style.h3}>가. 재산상태</p>

          <p className={style.h4}>(1) 현재 소유 중인 부동산</p>
          <p className={style.tit_sub_desc}>
            (분양권, 입주권 등도 포함되며 명의자 기준으로 작성) <br/>
            &#91;부동산의 <span className={style.red}>주소를 명확히 기재해주시고, 알지 못하는 경우 “주소 모름”으로 기재</span>해주세요&#93;
          </p>

          <div className={style.add_box_wrapper}>
            <p className={style.h2}>의뢰인</p>
            <div className={style.btn_box}>
              <div className={style.btn}  onClick={() => handleDeleteItem("realty_my")}>
                <img src='images/btn_delete.webp' alt='삭제 버튼' />
              </div>
              <div className={style.btn} onClick={() => handleAddItem("realty_my")}>
                <img src='images/btn_plus.webp' alt='추가 버튼'  />
              </div>
            </div>

            {propertyMyRealty.map((item, index) => <PropertyRealty key={index} index={index} key_name={"realty_my"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
          </div>

          <div className={style.add_box_wrapper}>
            <p className={style.h2}>상대방</p>
            <div className={style.btn_box}>
              <div className={style.btn} onClick={() => handleDeleteItem("realty_spouse")}>
                <img src='images/btn_delete.webp' alt='삭제 버튼' />
              </div>
              <div className={style.btn} onClick={() => handleAddItem("realty_spouse")}>
                <img src='images/btn_plus.webp' alt='추가 버튼'  />
              </div>
            </div>

            {propertySpouseRealty.map((item, index) => <PropertyRealty key={index} index={index} key_name={"realty_spouse"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
          </div>


        </section>

      ) : null}

      {/* 5. 재산 분할 - 가 - (2) 금융자산 */}
      { tab === "finance" ? (

      <section>

        <p className={style.main_tit}>5. 재산분할</p>

        <p className={style.h4}>(2) 금융자산</p>
        <p className={style.tit_sub_desc}>
          (예금, 적금, 보험, 주식, 코인 등) <br/>
          &#91;상대방의 금융재산 중 <span className={style.red}>정확한 금융기관을 모르는 경우에는 ‘알지 못함’으로 기재</span>해주세요&#93;
        </p>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>의뢰인</p>
          <div className={style.btn_box}>
            <div className={style.btn} onClick={() => handleDeleteItem("finance_my")}>
              <img src='images/btn_delete.webp' alt='삭제 버튼' />
            </div>
            <div className={style.btn} onClick={() => handleAddItem("finance_my")}>
              <img src='images/btn_plus.webp' alt='추가 버튼'  />
            </div>
          </div>

          {propertyMyFinance.map((item, index) => <PropertyFinance key={index} index={index} key_name={"finance_my"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
        </div>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>상대방</p>
          <div className={style.btn_box}>
            <div className={style.btn} onClick={() => handleDeleteItem("finance_spouse")}>
              <img src='images/btn_delete.webp' alt='삭제 버튼' />
            </div>
            <div className={style.btn} onClick={() => handleAddItem("finance_spouse")}>
              <img src='images/btn_plus.webp' alt='추가 버튼'  />
            </div>
          </div>

          {propertySpouseFinance.map((item, index) => <PropertyFinance key={index} index={index} key_name={"finance_spouse"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
        </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 가 - (3) 차량 */}
      { tab === "car" ? (

      <section>

      <p className={style.main_tit}>5. 재산분할</p>

      <p className={style.h4}>(3) 차량</p>
      <p className={style.tit_sub_desc}>
        (차량 종류, 차량번호, 대략적인 시가, 할부 혹은 대출금 존재하는지 등)
      </p>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>의뢰인</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("car_my")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("car_my")}>
            <img src='images/btn_plus.webp' alt='추가 버튼'  />
          </div>
        </div>

        {propertyMyCar.map((item, index) => <PropertyCar key={index} index={index} key_name={"car_my"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/>)}
      </div>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>상대방</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("car_spouse")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("car_spouse")}>
            <img src='images/btn_plus.webp' alt='추가 버튼'  />
          </div>
        </div>

        {propertySpouseCar.map((item, index) => <PropertyCar key={index} index={index} key_name={"car_spouse"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/>)}
      </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 가 - (4) 채권 */}
      { tab === "bond" ? (

      <section>

      <p className={style.main_tit}>5. 재산분할</p>

      <p className={style.h4}>(4) 채권</p>
      <p className={style.tit_sub_desc}>
          (향후 받아야 하는 돈) <br/>
          &#91;(예) 임대차보증금반환채권, 타인에게 빌려준 돈, 퇴직금, 회원권 등/ <span className={style.red}>보증금채권이 존재하는 경우 ‘주소’를 기재</span>&#93;
      </p>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>의뢰인</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("bond_my")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("bond_my")} >
            <img src='images/btn_plus.webp' alt='추가 버튼' />
          </div>
        </div>

        {propertyMyBond.map((item, index) => <PropertyBond key={index} index={index} key_name={"bond_my"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
      </div>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>상대방</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("bond_spouse")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("bond_spouse")}>
            <img src='images/btn_plus.webp' alt='추가 버튼'  />
          </div>
        </div>

        {propertySpouseBond.map((item, index) => <PropertyBond key={index} index={index} key_name={"bond_spouse"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}
      </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 가 - (5) 채무 */}
      { tab === "debt" ? (

      <section>

      <p className={style.main_tit}>5. 재산분할</p>

      <p className={style.h4}>(5) 채무</p>
      <p className={style.tit_sub_desc}>
          (빚, 향후 줘야하는 돈) <br/>
          &#91;(예) 금융기관 대출, 임대차보증금반환 채무, 타인에게 갚아야 할 돈, <span className={style.red}>보증금반환채무가 존재 시 ‘주소’를 기재</span>&#93;
      </p>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>의뢰인</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("debt_my")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("debt_my")}>
            <img src='images/btn_plus.webp' alt='추가 버튼'  />
          </div>
        </div>

        {propertyMyDebt.map((item, index) => <PropertyDebt key={index} index={index} key_name={"debt_my"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/>)}
      </div>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>상대방</p>
        <div className={style.btn_box}>
          <div className={style.btn} onClick={() => handleDeleteItem("debt_spouse")}>
            <img src='images/btn_delete.webp' alt='삭제 버튼' />
          </div>
          <div className={style.btn} onClick={() => handleAddItem("debt_spouse")}>
            <img src='images/btn_plus.webp' alt='추가 버튼'  />
          </div>
        </div>

        {propertySpouseDebt.map((item, index) => <PropertyDebt key={index} index={index} key_name={"debt_spouse"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/>)}
      </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 나 */}
      { tab === "career" ? (

      <section>

        <p className={style.main_tit}>5. 재산분할</p>

        <p className={style.h3}>나. 직업변동 과정</p>
        <p className={style.tit_sub_desc}>
          &#91;결혼 전 의뢰인분과 상대방은 어떤 직업을 갖고 있었는지, 결혼 후 각자의 직업변동은 어떠한지, <span className={style.red}>현재의 직업과 월 수입은 어떤지 </span>알려주세요. 현재 직업이 회사원의 경우 직장명, 직급, 연봉등을 기재해주시면 되고, 사업을 하는 경우 어떤 종류의 사업을 하는지, 사업소득, 사업장 보증금이 있는지 알려주세요&#93;
        </p>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>의뢰인</p>
          <div className={style.item_input_text}>
            <p className={style.tit}>현재 월수입</p>
            <input type="text" name="career_my_income" placeholder='급여 월 300만원, 월세 수입 월 700만원' value={consult.filter((e)=>e.key === "career_my_income")[0].answer} onChange={handleInput}/>
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>상세</p>
            <div className={style.item_input_textarea}>
              <textarea name="career_my_detail" placeholder='대학을 졸업한 직후인 2010년 경 곧바로 00회사에 취업하였고, 이후 2013년 2월 경에 퇴사하여 6개월 정도의 휴직기를 갖다가, 자영업을 해야 겠다는 생각에 캠핑용품점을 차려 오늘날까지 계속 같은 곳에서 일하고 있음' value={consult.filter((e)=>e.key === "career_my_detail")[0].answer} onChange={handleInput}/>
            </div>
          </div>
        </div>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>상대방</p>

          <div className={style.item_input_text}>
            <p className={style.tit}>현재 월수입</p>
            <input type="text" name="career_spouse_income" placeholder='없음' value={consult.filter((e)=>e.key === "career_spouse_income")[0].answer} onChange={handleInput}/>
          </div>

          <div className={style.item_input_text}>
            <p className={style.tit}>상세</p>
            <div className={style.item_input_textarea}>
              <textarea name="career_spouse_detail" placeholder='대학을 졸업한 직후에 대학원에 진학하였고, 그러던 중 나를 만남. 대학원 졸업 후 00회사에서 일하였으나, 결혼과 동시에 일을 그만 둠. 결혼 직후 2년간 학생들 과외 아르바이트를 하였는데 그 이후로는 아예 일을 하지 않고 무직인 상태임.' value={consult.filter((e)=>e.key === "career_spouse_detail")[0].answer} onChange={handleInput}/>
            </div>
          </div>
        </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 다 */}
      { tab === "formation" ? (

      <section>

      <p className={style.main_tit}>5. 재산분할</p>

      <p className={style.h3}>다. 재산형성 과정</p>
      <p className={style.tit_sub_desc}>
        &#91;재산의 증식 및 감소와 관련된 사정을 아는 범위 내에서 적어주세요. 아울러 <span className={style.red}>의뢰인께서 재산 형성에 기여한 사정</span>(예: 수입이 있었음, 부동산을 투자하여 수익을 올림, 검소하게 지냄, 적금을 듬, 결혼할 때 내가 재산을 많이 갖고 옴 등등)에 대하여 작성해주세요&#93;
      </p>

      <p className={style.h4}>(1) 결혼 당시 의뢰인과 상대방이 가져온 재산</p>
      <p className={style.tit_sub_desc}>&#91;의뢰인과 상대방 집에서 지원해준 재산 포함, 결혼 비용은 누가 부담했는지(혼수, 결혼식 등)&#93;</p>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>의뢰인</p>

        <div className={style.item_input_text}>
          <div className={style.item_input_textarea}>
            <textarea name="formation_my_property" placeholder='내가 모아둔 현금 3천만 원, 내 소유 장미아파트(주소), 부모님 지원금 0원' value={consult.filter((e)=>e.key === "formation_my_property")[0].answer} onChange={handleInput}/>
          </div>
        </div>
      </div>

      <div className={style.add_box_wrapper}>
        <p className={style.h2}>상대방</p>

        <div className={style.item_input_text}>
          <div className={style.item_input_textarea}>
            <textarea name="formation_spouse_property" placeholder='상대방 예금 5천만 원, 부모님 지원금 2억원' value={consult.filter((e)=>e.key === "formation_spouse_property")[0].answer} onChange={handleInput}/>
          </div>
        </div>
      </div>

      <p className={style.h4}>(2) 결혼 후 재산 형성 과정 및 의뢰인의 기여도에 대하여</p>
      <div className={style.item_input_text}>
        <div className={style.item_input_textarea}>
          <textarea name="formation_detail" placeholder='2007. 3. 5. 결혼 후 본인이 모아둔 1200만 원과 남편이 모아둔 400만 원으로 1600만원을 만들어 전세로 신혼살림을 시작하였다. 이 집에서 첫째 딸을 93년도 5월에 낳았습니다. 월급을 계속 모아 2200만원을 모아서 5년 뒤에 서울 00시 00구 00아파트 전셋집으로 이사하였고,' value={consult.filter((e)=>e.key === "formation_detail")[0].answer} onChange={handleInput}/>
        </div>
      </div>

      </section>

      ) : null}

      {/* 5. 재산 분할 - 라 */}
      { tab === "check" ? (

      <section>

        <p className={style.main_tit}>5. 재산분할</p>

        <p className={style.h3}>라. 상대방 재산 조회 원하시는지 여부</p>
        <p className={style.tit_sub_desc}>
          &#91;<span className={style.red}>소송 절차를 통해 상대방의 재산을 탐색</span>할 것인지에 관한 질문입니다. 특히 상대방의 재산을 잘 모르는 경우에 필요합니다. 대륜에서는 법원 절차상 가능한 여러 방법으로 재산 탐색을 도와드리고자 합니다. 다만 상대방의 재산을 조회하거나 재산명시하라고 신청 시, 상대방 또한 의뢰인분의 재산을 조회하거나 재산명시하라는 신청을 할 수 있습니다&#93;
        </p>

        <div className={style.check_wrapper}>
          <p className={style.h4}>(1) 부동산, 주식, 예금, 보험, 퇴직금 등의 조회를 원하는지</p>
            <label 
              htmlFor="check_1_1"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_1"
                id="check_1_1"
                value="예"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_1")[0].answer === "예"}
              />
              <span className={style.checkbox}></span>
              예
            </label>

            <div className={style.add_box_wrapper}>
              <div className={style.add_txt}>

                <p className={style.tit_sub_desc}>
                  퇴직금 조회를 원하는 경우, 상대방 재직 회사명(모를 경우, 모른다고 기재)과 그 소재지(정확한 주소를 모르는 경우, 서울 종로구 위치함 정도로 기재)를 알려주세요
                </p>
              
                <div className={style.item_input_text}>
                  <p className={style.tit}>회사명</p>
                  <input type="text" name="check_1_company" placeholder='모름' value={consult.filter((e)=>e.key === "check_1_company")[0].answer} onChange={handleInput} disabled={consult.filter((e) => e.key === "check_1")[0].answer !== "예"}/>
                </div>

                <div className={style.item_input_text}>
                  <p className={style.tit}>소재지</p>
                  <input type="text" name="check_1_address" placeholder='서울 종로구 위치함' value={consult.filter((e)=>e.key === "check_1_address")[0].answer} onChange={handleInput} disabled={consult.filter((e) => e.key === "check_1")[0].answer !== "예"}/>
                </div>

              </div>
            </div>

            <label 
              htmlFor="check_1_2"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_1"
                id="check_1_2"
                value="아니오"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_1")[0].answer === "아니오"}
              />
              <span className={style.checkbox}></span>
              아니오
            </label>

            <label 
              htmlFor="check_1_3"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_1"
                id="check_1_3"
                value="예금만 원함"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_1")[0].answer === "예금만 원함"}
              />
              <span className={style.checkbox}></span>
              예금만 원함
            </label>
        </div>


        <div className={style.check_wrapper}>
          <p className={style.h4}>(2) 부동산, 주식, 예금, 보험, 퇴직금 등의 조회를 원하는지</p>
          <p className={style.tit_sub_desc}>
            (상대방에게 보유하고 있는 재산이 무엇인지 밝히라는 것, 각자 가진 재산을 임의로 밝히는 것이므로 시간을 단축시킬 수 있습니다. 재산명시신청을 하더라도 위 (1)항의 금융재산 조회 등은 가능합니다.)
          </p>

            <label 
              htmlFor="check_2-1"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_2"
                id="check_2-1"
                value="예"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_2")[0].answer === "예"}
              />
              <span className={style.checkbox}></span>
              예
            </label>

            <label 
              htmlFor="check_2_2"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_2"
                id="check_2_2"
                value="아니오"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_2")[0].answer === "아니오"}
              />
              <span className={style.checkbox}></span>
              아니오
            </label>
        </div>

        <div className={style.check_wrapper}>
          <p className={style.h4}>(3) 기타 확인하고 싶은 재산이 있으신지</p>
          <p className={style.tit_sub_desc}>
            (있을 경우 기재해주시면 담당변호사가 검토할 예정)
          </p>

            <label 
              htmlFor="check_3-1"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_3"
                id="check_3-1"
                value="예"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_3")[0].answer === "예"}
              />
              <span className={style.checkbox}></span>
              예
            </label>

            <div className={style.item_input_text}>
              <div className={style.item_input_textarea}>
                <textarea name="check_3_detail" placeholder='내가 모아둔 현금 3천만 원, 내 소유 장미아파트(주소), 부모님 지원금 0원' value={consult.filter((e)=>e.key === "check_3_detail")[0].answer} onChange={handleInput} disabled={consult.filter((e) => e.key === "check_3")[0].answer !== "예"}/>
              </div>
            </div>

            <label 
              htmlFor="check_3_2"
              className={style.custom_checkbox}
            >
              <input
                type="radio"
                className={style.r_btn}
                name="check_3"
                id="check_3_2"
                value="아니오"
                onChange={handleInput}
                checked={consult.filter((e) => e.key === "check_3")[0].answer === "아니오"}
              />
              <span className={style.checkbox}></span>
              아니오
            </label>
        </div>

      </section>

      ) : null}

      {/* 재산명세표 */}
      { tab === "sheet" ? (

      <section>

        <p className={style.main_tit}>재산명세표</p>

        <div className={style.add_txt}>
          <p className={style.tit_desc}>
            &#8226; 사건 검토를 위한 자료로 현재 시점에 존재하는 재산 전부에 대하여 기재해주시면 됩니다.
          </p>
          <p className={style.tit_desc}>
            &#8226; 상대방 재산에 대해 정확히 알지 못하는 경우, 대략적인 내용이라도 적어주세요. (예: 보험이 있으나 가액 모름)
          </p>
          <p className={style.tit_desc}>
            &#8226; <span className={style.bold}>목록에 기재하는 “재산”란의 종류 예시)</span> 부동산, 분양권, 입주권, 예금, 펀드, 주식, 코인, 보험계약자인 경우 해지환급금, 퇴직금, 차량, 임대차보증금반환채권, 빌려준 돈(채권) 등
          </p>
          <p className={style.tit_desc}>
            &#8226; <span className={style.bold}>목록에 기재하는 “채무”란의 종류 예시)</span> 부동산 담보대출금, 금융기관 대출, 마이너스(통장) 대출, 보험약관대출금, 임대차보증금반환채무, 사채, 타인에게 빌린 돈(차용금 채무) 등
          </p>
        </div>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>의뢰인</p>
          <div className={style.h4}>재산
              <div className={style.btn_box_lower}>
                <div className={style.btn} onClick={() => handleDeleteItem("sheet_my_property")}>
                  <img src='images/btn_delete.webp' alt='삭제 버튼'  />
                </div>
                <div className={style.btn} onClick={() => handleAddItem("sheet_my_property")}>
                  <img src='images/btn_plus.webp' alt='추가 버튼'  />
                </div>
              </div>
          </div>

          {sheetMyProperty.map((item, index) => <SheetProperty key={index} index={index} key_name={"sheet_my_property"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}

          <div className={style.worth_wrapper}>
            <p className={style.tit}>재산 합계</p>
            <div className={style.txt_wrapper}>{comma(myProperty)}원</div>
          </div>
          {/* sumItem */}
          <div className={style.h4}>채무
              <div className={style.btn_box_lower}>
                <div className={style.btn}  onClick={() => handleDeleteItem("sheet_my_debt")}>
                  <img src='images/btn_delete.webp' alt='삭제 버튼' />
                </div>
                <div className={style.btn} onClick={() => handleAddItem("sheet_my_debt")}>
                  <img src='images/btn_plus.webp' alt='추가 버튼'  />
                </div>
              </div>
          </div>

          {sheetMyDebt.map((item, index) => <SheetDebt key={index} index={index} key_name={"sheet_my_debt"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}

          <div className={style.worth_wrapper}>
            <p className={style.tit}>채무 합계</p>
            <div className={style.txt_wrapper}>{comma(myDebt)}원</div>
          </div>

          <div className={style.net_worth_wrapper}>
            <p className={style.tit}>의뢰인의 순재산</p>
            <div className={style.txt_wrapper}>{comma(myProperty - myDebt)}원</div>
          </div>
        </div>

        <div className={style.add_box_wrapper}>
          <p className={style.h2}>상대방</p>
          <div className={style.h4}>재산
              <div className={style.btn_box_lower}>
                <div className={style.btn} onClick={() => handleDeleteItem("sheet_spouse_property")} >
                  <img src='images/btn_delete.webp' alt='삭제 버튼' />
                </div>
                <div className={style.btn} onClick={() => handleAddItem("sheet_spouse_property")}>
                  <img src='images/btn_plus.webp' alt='추가 버튼' />
                </div>
              </div>
          </div>

          {sheetSpouseProperty.map((item, index) => <SheetProperty key={index} index={index} key_name={"sheet_spouse_property"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}

          <div className={style.worth_wrapper}>
            <p className={style.tit}>재산 합계</p>
            <div className={style.txt_wrapper}>{comma(spouseProperty)}원</div>
          </div>

          <div className={style.h4}>채무
              <div className={style.btn_box_lower}>
                <div className={style.btn} onClick={() => handleDeleteItem("sheet_spouse_debt")}>
                  <img src='images/btn_delete.webp' alt='삭제 버튼' />
                </div>
                <div className={style.btn} onClick={() => handleAddItem("sheet_spouse_debt")}>
                  <img src='images/btn_plus.webp' alt='추가 버튼' />
                </div>
              </div>
          </div>

          {sheetSpouseDebt.map((item, index) => <SheetDebt key={index} index={index} key_name={"sheet_spouse_debt"} handleInput={handleInput} getLocalStorage={getLocalStorage} data={item}/> )}

          <div className={style.worth_wrapper}>
            <p className={style.tit}>채무 합계</p>
            <div className={style.txt_wrapper}>{comma(spouseDebt)}원</div>
          </div>

          <div className={style.net_worth_wrapper}>
            <p className={style.tit}>상대방의 순재산</p>
            <div className={style.txt_wrapper}>{comma(spouseProperty - spouseDebt)}원</div>
          </div>

          <div className={style.final_worth_wrapper}>
            <p className={style.tit}><span className={style.red}>부부 순재산의 합계</span></p>
            <div className={style.txt_wrap}>{comma(myProperty - myDebt + spouseProperty - spouseDebt)}원</div>
          </div>
        </div>


      </section>

      ) : null}

      {/* 하단 버튼 */}
      { (tab === "info") ? (
          <div className={style.btn_wrapper_1} onClick={nextStep}>
            <div className={style.start_btn}>다음</div>
          </div>
        ) : (tab === "sheet") ? (
          <div className={style.btn_wrapper_2}>
              <div className={style.before_btn} onClick={beforeStep}>이전</div>
              <div className={style.finish_btn} onClick={consultCheck2}>완료</div>
          </div>
        ): (
            <div className={style.btn_wrapper_2}>
              <div className={style.before_btn} onClick={beforeStep}>이전</div>
              <div className={style.start_btn} onClick={nextStep}>다음</div>
            </div>
      )}
    </>
  )
}

export default Divorce